module.exports = __webpack_public_path__ + "static/media/Source Info.d3c93e69.txt";